import i18n from "./_snowpack/pkg/i18next.js";
import {initReactI18next} from "./_snowpack/pkg/react-i18next.js";
import LanguageDetector from "./_snowpack/pkg/i18next-browser-languagedetector.js";
import Backend from "./_snowpack/pkg/i18next-http-backend.js";
i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init({
  detection: {
    order: ["querystring", "navigator"]
  },
  fallbackLng: "en",
  debug: false,
  load: "languageOnly",
  interpolation: {
    escapeValue: false
  }
});
export default i18n;
